import {FlagProps, Label, Separator} from 'platform/components';
import {Heading, VStack} from 'platform/foundation';

import {indexBy, isNotNil} from 'ramda';

import {useGetBranchListQuery} from '@dms/api/core';
import {useGetBranchSettingValuesQuery} from '@dms/api/settings';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsSection, SettingsTemplate} from '@dms/settings/shared';

import {buildArray} from 'shared/web';

import {BranchCard} from './components/BranchCard';
import {TenantSection} from './components/TenantSection';

export function TenantLogos() {
  const {data: branchLogosDocument} = useGetBranchSettingValuesQuery({
    settingId: 'tenant-logo_document',
  });
  const {data: branchLogosEmail} = useGetBranchSettingValuesQuery({settingId: 'tenant-logo_email'});

  const branchLogosDocumentById = indexBy((item) => item.branchId, branchLogosDocument ?? []);
  const branchLogosEmailById = indexBy((item) => item.branchId, branchLogosEmail ?? []);

  const {data: branches} = useGetBranchListQuery();

  return (
    <SettingsTemplate
      data-testid={testIds.settings.tenantLogos('template')}
      header={{title: i18n.t('page.settings.labels.tenantLogs')}}
    >
      <SettingsSection>
        <VStack spacing={2}>
          <Heading size={4}>{i18n.t('page.settings.labels.generalLogos')}</Heading>
          <Label>{i18n.t('page.settings.labels.generalLogosDescription')}</Label>

          <TenantSection />

          <Separator />

          <Heading size={4}>{i18n.t('page.settings.labels.branchLogos')}</Heading>
          {branches?.branchListItems?.map((branch) => {
            const branchDocumentImage = branchLogosDocumentById[branch.id]?.value?.fileId ?? null;
            const branchEmailImage = branchLogosEmailById[branch.id]?.value?.fileId ?? null;

            const isDocumentImageCustomized = isNotNil(branchDocumentImage);
            const isEmailImageCustomized = isNotNil(branchEmailImage);

            const flags = buildArray<FlagProps>()
              .when(isDocumentImageCustomized, {
                label: i18n.t('page.settings.labels.documentLogo'),
                size: 'small',
                isSubtle: true,
              })
              .when(isEmailImageCustomized, {
                label: i18n.t('page.settings.labels.emailLogo'),
                size: 'small',
              });

            return (
              <BranchCard
                key={branch.id}
                branch={branch}
                flags={flags}
                documentImage={branchDocumentImage}
                emailImage={branchEmailImage}
              />
            );
          })}
        </VStack>
      </SettingsSection>
    </SettingsTemplate>
  );
}
